export interface CarSpec {
    label: string;
    value: string;
    icon: string;
}

export interface Car {
    id: number;
    title: string;
    price: string;
    image: string;
    badge?: string;
    specs: CarSpec[];
    description: string[];
    engine: string;
    transmission: string;
    mileage: string;
    images: string[];
    thumbnails: string[];
}

export const carData: Car[] = [
    {
        id: 1,
        title: "Mercedes Benz E class station wagon",
        price: "125,000,000 ₮",
        image: "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-001-Q-TE-DR.jpg",
        badge: "NEW",
        engine: "2.0L",
        transmission: "Automatic",
        mileage: "99,000 km",
        images: [
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-001-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-002-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-008-C-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-004-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-005-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-009-C-TE-DR.jpg",
        ],
        thumbnails: [
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-001-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-002-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-008-C-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-004-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-005-Q-TE-DR.jpg",
            "https://www.mbusa.com/content/dam/mb-nafta/us/myco/my25/e-class/e-wagon/gallery/series/gallery-type/2025-E-WAGON-GAL-009-C-TE-DR.jpg",
        ],
        specs: [
            { label: "Мотор багтаамж", value: "2.0 л", icon: "faGasPump" },
            { label: "Хөдөлгүүр", value: "Бензин", icon: "fas fa-cog" },
            { label: "Хурдны хайрцаг", value: "Автомат", icon: "fas fa-tachometer-alt" },
            { label: "Дотор өнгө", value: "Хар", icon: "fas fa-palette" },
            { label: "Хүрд", value: "Буруу", icon: "fas fa-car-side" },
            { label: "Лизинг", value: "ББСБ лизингтэй", icon: "fas fa-file-contract" },
            { label: "Төрөл", value: "Гэр бүлийн", icon: "fas fa-chair" },
            { label: "Хөтлөгч", value: "Хойноо RWD", icon: "fas fa-car" },
            { label: "Өнгө", value: "Сувдан цагаан", icon: "fas fa-paint-brush" },
            { label: "Явсан", value: "99000 км", icon: "fas fa-road" },
            { label: "Үйлдвэрлэсэн он", value: "2017", icon: "fas fa-calendar-alt" },
            { label: "Нөхцөл", value: "Дугаар авсан", icon: "fas fa-id-card" },
            { label: "Орж ирсэн он", value: "2024", icon: "fas fa-calendar-plus" },
            { label: "Хаалга", value: "5", icon: "fas fa-door-open" }
        ],
        description: [
            "- 2016 оны 12 сард үйлдвэрлэсэн",
            "- 2024 оны 10 сард дугаар авсан",
            "- 2.0 Turbo хөдөлгүүртэй",
            "- Stage 1 tuning хийсэн",
            "- Бүх option байгаа"
        ]
    },
    {
        id: 2,
        title: "BMW M4 Competition",
        price: "185,000,000 ₮",
        image: "https://bmw.scene7.com/is/image/BMW/BMW-MY25-M4-Comp-DI23__000192907_LSQ_0006_G22_MPA_Front_Firered-Retouched:3to2?fmt=webp&wid=2560&hei=1707",
        badge: "POPULAR",
        engine: "3.0L",
        transmission: "Automatic",
        mileage: "45,000 km",
        images: [
            "https://bmw.scene7.com/is/image/BMW/BMW-MY25-M4-Comp-DI23__000192907_LSQ_0006_G22_MPA_Front_Firered-Retouched:3to2?fmt=webp&wid=2560&hei=1707",
            "https://bmw.scene7.com/is/image/BMW/BMW-MY25-4Coupe-DI23_000192860-Retouched-1:3to2?fmt=webp&wid=2560&hei=1707",
            "https://bmw.scene7.com/is/image/BMW/BMW-MY25-DI23_000192885_LSQ_0009_G22_MPA_Dashboard_OS_8_0_v2-retouched-sleek-display:3to2?fmt=webp&wid=2560&hei=1707",
        ],
        thumbnails: [
            "https://bmw.scene7.com/is/image/BMW/BMW-MY25-M4-Comp-DI23__000192907_LSQ_0006_G22_MPA_Front_Firered-Retouched:3to2?fmt=webp&wid=2560&hei=1707",
            "https://bmw.scene7.com/is/image/BMW/BMW-MY25-4Coupe-DI23_000192860-Retouched-1:3to2?fmt=webp&wid=2560&hei=1707",
            "https://bmw.scene7.com/is/image/BMW/BMW-MY25-DI23_000192885_LSQ_0009_G22_MPA_Dashboard_OS_8_0_v2-retouched-sleek-display:3to2?fmt=webp&wid=2560&hei=1707",
        ],
        specs: [
            { label: "Мотор багтаамж", value: "3.0 л", icon: "faGasPump" },
            { label: "Хөдөлгүүр", value: "Бензин", icon: "fas fa-cog" },
            { label: "Хурдны хайрцаг", value: "Автомат", icon: "fas fa-tachometer-alt" },
            { label: "Дотор өнгө", value: "Хар", icon: "fas fa-palette" },
            { label: "Хүрд", value: "Бүтэн", icon: "fas fa-car-side" },
            { label: "Лизинг", value: "Төрийн банкны лизингтэй", icon: "fas fa-file-contract" },
            { label: "Төрөл", value: "Спорт", icon: "fas fa-chair" },
            { label: "Хөтлөгч", value: "Арын RWD", icon: "fas fa-car" },
            { label: "Өнгө", value: "Саарал", icon: "fas fa-paint-brush" },
            { label: "Явсан", value: "45000 км", icon: "fas fa-road" },
            { label: "Үйлдвэрлэсэн он", value: "2019", icon: "fas fa-calendar-alt" },
            { label: "Нөхцөл", value: "Дугаар авсан", icon: "fas fa-id-card" },
            { label: "Орж ирсэн он", value: "2023", icon: "fas fa-calendar-plus" },
            { label: "Хаалга", value: "2", icon: "fas fa-door-open" }
        ],
        description: [
            "- 2019 оны 6 сард үйлдвэрлэсэн",
            "- 2023 оны 5 сард дугаар авсан",
            "- 3.0 TwinPower Turbo хөдөлгүүртэй",
            "- M Sport package",
            "- Carbon fiber accents"
        ]
    },
    {
        id: 3,
        title: "Toyota Land Cruiser Prado",
        price: "145,000,000 ₮",
        image: "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0018_V002.png:tcom_gallery_4x3?ts=1757451444508&fmt=jpg&fit=crop&dpr=on,2",
        badge: "BEST VALUE",
        engine: "2.8L",
        transmission: "Automatic",
        mileage: "78,000 km",
        images: [
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0018_V002.png:tcom_gallery_4x3?ts=1757451444508&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0021_V001.png:tcom_gallery_1x1?ts=1757451444532&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0010_V004.png:tcom_gallery_4x3?ts=1757451444521&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0047_V001.png:tcom_gallery_1x1?ts=1757451444544&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0046_V001.png:tcom_gallery_16x9?ts=1757451444586&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/MUL_MY24_0036_V002.png:tcom_gallery_4x3?ts=1757451444640&fmt=jpg&fit=crop&dpr=on,2"
        ],
        thumbnails: [
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0018_V002.png:tcom_gallery_4x3?ts=1757451444508&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0021_V001.png:tcom_gallery_1x1?ts=1757451444532&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0010_V004.png:tcom_gallery_4x3?ts=1757451444521&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0047_V001.png:tcom_gallery_1x1?ts=1757451444544&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/LND_MY24_0046_V001.png:tcom_gallery_16x9?ts=1757451444586&fmt=jpg&fit=crop&dpr=on,2",
            "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/vehicles/2026/landcruiser/galleries/MUL_MY24_0036_V002.png:tcom_gallery_4x3?ts=1757451444640&fmt=jpg&fit=crop&dpr=on,2"
        ],
        specs: [
            { label: "Мотор багтаамж", value: "2.8 л", icon: "faGasPump" },
            { label: "Хөдөлгүүр", value: "Дизель", icon: "fas fa-cog" },
            { label: "Хурдны хайрцаг", value: "Автомат", icon: "fas fa-tachometer-alt" },
            { label: "Дотор өнгө", value: "Саарал", icon: "fas fa-palette" },
            { label: "Хүрд", value: "Бүтэн", icon: "fas fa-car-side" },
            { label: "Лизинг", value: "Хаан банкны лизингтэй", icon: "fas fa-file-contract" },
            { label: "Төрөл", value: "SUV", icon: "fas fa-chair" },
            { label: "Хөтлөгч", value: "Дөрвөн дугуйт 4WD", icon: "fas fa-car" },
            { label: "Өнгө", value: "Цагаан", icon: "fas fa-paint-brush" },
            { label: "Явсан", value: "78000 км", icon: "fas fa-road" },
            { label: "Үйлдвэрлэсэн он", value: "2018", icon: "fas fa-calendar-alt" },
            { label: "Нөхцөл", value: "Дугаар авсан", icon: "fas fa-id-card" },
            { label: "Орж ирсэн он", value: "2022", icon: "fas fa-calendar-plus" },
            { label: "Хаалга", value: "5", icon: "fas fa-door-open" }
        ],
        description: [
            "- 2018 оны 3 сард үйлдвэрлэсэн",
            "- 2022 оны 8 сард дугаар авсан",
            "- 2.8L турбо дизель хөдөлгүүртэй",
            "- 7 суудалтай",
            "- Агааржуулалт, халаалттай суудал"
        ]
    },
    {
        id: 4,
        title: "Honda CR-V EX",
        price: "85,000,000 ₮",
        image: "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-119-647e0618426ee.jpg?crop=0.913xw:0.685xh;0.0865xw,0.221xh&resize=1200:*",
        engine: "1.5L",
        transmission: "Automatic",
        mileage: "52,000 km",
        images: [
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-119-647e0618426ee.jpg?crop=0.913xw:0.685xh;0.0865xw,0.221xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-119-647e04f878dfb.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-115-647e04f5a8435.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-117-647e04f5f215d.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-107-647e04f33a69f.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-110-647e04f39a685.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-109-647e04f349260.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-103-647e04f29a604.jpg?crop=1xw:1xh;center,top"


        ],
        thumbnails: [
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-119-647e0618426ee.jpg?crop=0.913xw:0.685xh;0.0865xw,0.221xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-119-647e04f878dfb.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-115-647e04f5a8435.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-117-647e04f5f215d.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-107-647e04f33a69f.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-110-647e04f39a685.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-109-647e04f349260.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2023-honda-crv-exl-103-647e04f29a604.jpg?crop=1xw:1xh;center,top"
        ],
        specs: [
            { label: "Мотор багтаамж", value: "1.5 л", icon: "faGasPump" },
            { label: "Хөдөлгүүр", value: "Бензин", icon: "fas fa-cog" },
            { label: "Хурдны хайрцаг", value: "Автомат", icon: "fas fa-tachometer-alt" },
            { label: "Дотор өнгө", value: "Хар", icon: "fas fa-palette" },
            { label: "Хүрд", value: "Урд", icon: "fas fa-car-side" },
            { label: "Лизинг", value: "Лизинггүй", icon: "fas fa-file-contract" },
            { label: "Төрөл", value: "SUV", icon: "fas fa-chair" },
            { label: "Хөтлөгч", value: "Урд FWD", icon: "fas fa-car" },
            { label: "Өнгө", value: "Мөнгөлөг саарал", icon: "fas fa-paint-brush" },
            { label: "Явсан", value: "52000 км", icon: "fas fa-road" },
            { label: "Үйлдвэрлэсэн он", value: "2020", icon: "fas fa-calendar-alt" },
            { label: "Нөхцөл", value: "Дугаар авсан", icon: "fas fa-id-card" },
            { label: "Орж ирсэн он", value: "2021", icon: "fas fa-calendar-plus" },
            { label: "Хаалга", value: "5", icon: "fas fa-door-open" }
        ],
        description: [
            "- 2020 оны 9 сард үйлдвэрлэсэн",
            "- 2021 оны 2 сард дугаар авсан",
            "- 1.5L VTEC Turbo хөдөлгүүртэй",
            "- Apple CarPlay, Android Auto",
            "- Аюулгүй байдлын олон системтэй"
        ]
    },
    {
        id: 5,
        title: "Audi Q7 Premium Plus",
        price: "165,000,000 ₮",
        image: "https://hips.hearstapps.com/hmg-prod/images/2025-audi-q7-102-66edd2912544c.jpg?crop=0.720xw:0.608xh;0.163xw,0.313xh&resize=1200:*",
        badge: "LUXURY",
        engine: "3.0L",
        transmission: "Automatic",
        mileage: "65,000 km",
        images: [
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-q7-102-66edd2912544c.jpg?crop=0.720xw:0.608xh;0.163xw,0.313xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-sq7-126-66edd2cee9a5d.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-sq7-180-66edd13eaecaf.jpg?crop=1.00xw:0.753xh;0,0.127xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-sq7-143-66edd13e12b96.jpg?crop=1xw:1xh;center,top",
        ],
        thumbnails: [
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-q7-102-66edd2912544c.jpg?crop=0.720xw:0.608xh;0.163xw,0.313xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-sq7-126-66edd2cee9a5d.jpg?crop=1xw:1xh;center,top",
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-sq7-180-66edd13eaecaf.jpg?crop=1.00xw:0.753xh;0,0.127xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2025-audi-sq7-143-66edd13e12b96.jpg?crop=1xw:1xh;center,top",
        ],
        specs: [
            { label: "Мотор багтаамж", value: "3.0 л", icon: "faGasPump" },
            { label: "Хөдөлгүүр", value: "Бензин", icon: "fas fa-cog" },
            { label: "Хурдны хайрцаг", value: "Автомат", icon: "fas fa-tachometer-alt" },
            { label: "Дотор өнгө", value: "Хар", icon: "fas fa-palette" },
            { label: "Хүрд", value: "Бүтэн", icon: "fas fa-car-side" },
            { label: "Лизинг", value: "Хаан банкны лизингтэй", icon: "fas fa-file-contract" },
            { label: "Төрөл", value: "Luxury SUV", icon: "fas fa-chair" },
            { label: "Хөтлөгч", value: "Дөрвөн дугуйт Quattro", icon: "fas fa-car" },
            { label: "Өнгө", value: "Хар", icon: "fas fa-paint-brush" },
            { label: "Явсан", value: "65000 км", icon: "fas fa-road" },
            { label: "Үйлдвэрлэсэн он", value: "2019", icon: "fas fa-calendar-alt" },
            { label: "Нөхцөл", value: "Дугаар авсан", icon: "fas fa-id-card" },
            { label: "Орж ирсэн он", value: "2022", icon: "fas fa-calendar-plus" },
            { label: "Хаалга", value: "5", icon: "fas fa-door-open" }
        ],
        description: [
            "- 2019 оны 11 сард үйлдвэрлэсэн",
            "- 2022 оны 4 сард дугаар авсан",
            "- 3.0L TFSI V6 хөдөлгүүртэй",
            "- Virtual Cockpit технологитой",
            "- Premium Plus package"
        ]
    },
    {
        id: 6,
        title: "Hyundai Tucson Ultimate",
        price: "95,000,000 ₮",
        image: "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-111-660424e19bc9d.jpg?crop=0.728xw:0.546xh;0.143xw,0.399xh&resize=1200:*",
        badge: "FEATURED",
        engine: "2.5L",
        transmission: "Automatic",
        mileage: "38,000 km",
        images: [
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-111-660424e19bc9d.jpg?crop=0.728xw:0.546xh;0.143xw,0.399xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-105-660424df2047f.jpg?crop=1.00xw:0.847xh;0,0.0765xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-113-660424e72fa01.jpg?crop=1.00xw:0.847xh;0,0.0816xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-114-660424e73644f.jpg?crop=1.00xw:0.847xh;0,0.0663xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-104-660424e4bb514.jpg?crop=1.00xw:0.847xh;0,0.0740xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-108-660424e50648e.jpg?crop=1.00xw:0.847xh;0,0.0510xh",
        ],
        thumbnails: [
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-111-660424e19bc9d.jpg?crop=0.728xw:0.546xh;0.143xw,0.399xh&resize=1200:*",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-105-660424df2047f.jpg?crop=1.00xw:0.847xh;0,0.0765xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-113-660424e72fa01.jpg?crop=1.00xw:0.847xh;0,0.0816xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-114-660424e73644f.jpg?crop=1.00xw:0.847xh;0,0.0663xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-104-660424e4bb514.jpg?crop=1.00xw:0.847xh;0,0.0740xh",
            "https://hips.hearstapps.com/hmg-prod/images/2025-hyundai-tucson-phev-interior-108-660424e50648e.jpg?crop=1.00xw:0.847xh;0,0.0510xh",
        ],
        specs: [
            { label: "Мотор багтаамж", value: "2.5 л", icon: "faGasPump" },
            { label: "Хөдөлгүүр", value: "Бензин", icon: "fas fa-cog" },
            { label: "Хурдны хайрцаг", value: "Автомат", icon: "fas fa-tachometer-alt" },
            { label: "Дотор өнгө", value: "Саарал", icon: "fas fa-palette" },
            { label: "Хүрд", value: "Урд", icon: "fas fa-car-side" },
            { label: "Лизинг", value: "Төрийн банкны лизингтэй", icon: "fas fa-file-contract" },
            { label: "Төрөл", value: "SUV", icon: "fas fa-chair" },
            { label: "Хөтлөгч", value: "Урд FWD", icon: "fas fa-car" },
            { label: "Өнгө", value: "Цэнхэр", icon: "fas fa-paint-brush" },
            { label: "Явсан", value: "38000 км", icon: "fas fa-road" },
            { label: "Үйлдвэрлэсэн он", value: "2021", icon: "fas fa-calendar-alt" },
            { label: "Нөхцөл", value: "Дугаар авсан", icon: "fas fa-id-card" },
            { label: "Орж ирсэн он", value: "2022", icon: "fas fa-calendar-plus" },
            { label: "Хаалга", value: "5", icon: "fas fa-door-open" }
        ],
        description: [
            "- 2021 оны 5 сард үйлдвэрлэсэн",
            "- 2022 оны 3 сард дугаар авсан",
            "- 2.5L GDI хөдөлгүүртэй",
            "- Ultimate trim level",
            "- 10.25-inch touchscreen navigation"
        ]
    }
];

// Function to get car by ID
export const getCarById = (id: number): Car | undefined => {
    return carData.find(car => car.id === id);
};

// Function to get all cars
export const getAllCars = (): Car[] => {
    return carData;
};